module.exports = __webpack_public_path__ + "img/1_1-commerciale-negozio-2.fd6d078c.png";